import { Component, Input, AfterViewInit, Output, EventEmitter, HostBinding, OnDestroy, ViewChild } from '@angular/core';
import { UIService } from './ui.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'ui-video',
	template:
		`<div class="position-relative w-100" style="border-radius: 0.25rem; overflow: hidden;">
			<video #videoPlayer width="100%" height="auto" [controls]="showControls" autoplay (ended)="onVideoEnded()"
				style="display: block;">
				<source [src]="videoURL" type="video/mp4">
				Your browser does not support the video tag.
			</video>

			<!-- Custom Play Button Overlay -->
			<div *ngIf="!hasStarted" class="d-flex align-items-center justify-content-center"
				style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8);">
				<button class="btn btn-lg btn-primary" (click)="startVideo()"><i class="wq wq-play mr-2"></i>Play</button>
			</div>
		</div>`
})
export class UIVideoComponent implements AfterViewInit, OnDestroy {

	@Input() videoURL = '';
	@Output() videoEnded = new EventEmitter<void>();
	@Input() showControls: boolean = true;
	@HostBinding('class') cls = 'd-flex align-items-center';
	@ViewChild('videoPlayer') videoPlayer;

	videoPlayCheckTimer: any;
	autoplayTimer: any;
	hasStarted = true;

	createSub: Subscription;

	constructor(
		private service: UIService
	) { }

	ngAfterViewInit() {
		this.service.onVideoCreated.emit();

		this.createSub = this.service.onVideoCreated.subscribe(() => {
			const videoElement: HTMLVideoElement = this.videoPlayer.nativeElement;
			if (!videoElement.paused) {
				videoElement.pause();
				this.hasStarted = false;
			}
		});

		this.autoplayTimer = setTimeout(() => {
			const videoElement: HTMLVideoElement = this.videoPlayer.nativeElement;

			if (videoElement) {
				videoElement.autoplay = true;
				videoElement.play()
					.then(() => this.hasStarted = true)
					.catch(() => this.hasStarted = false);
			}

		}, 500);

		this.videoPlayCheckTimer = setTimeout(() => {
			const videoElement: HTMLVideoElement = this.videoPlayer.nativeElement;

			if (videoElement.paused) {
				this.hasStarted = false;
			}
		}, 5000);
	}

	onVideoEnded() {
		this.showControls = true;
		this.videoEnded.emit();
	}

	startVideo() {
		const videoElement: HTMLVideoElement = this.videoPlayer.nativeElement;
		if (videoElement) {
			videoElement.muted = false;
			videoElement.play()
				.then(() => this.hasStarted = true)
				.catch(() => this.hasStarted = false);
		}
	}

	ngOnDestroy() {
		if (this.createSub) this.createSub.unsubscribe();

		const videoElement: HTMLVideoElement = this.videoPlayer.nativeElement;
		if (videoElement) videoElement.removeEventListener('ended', this.onVideoEnded);

		clearTimeout(this.autoplayTimer);
		clearTimeout(this.videoPlayCheckTimer);
	}

}
